import script from "./builds-content.vue?vue&type=script&setup=true&lang=ts"
export * from "./builds-content.vue?vue&type=script&setup=true&lang=ts"

import "./builds-content.vue?vue&type=style&index=0&id=31084650&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31084650"]])

export default __exports__